<script setup lang="ts">
import {PropType} from "vue";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import SecurityUtils from "@/utils/login/SecurityUtils.ts";
import ScreenActionWidget from "@/components/EditView/widgets/ScreenActionWidget.vue";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import GUIActionInfo = namaTypes.GUIActionInfo;
import EditScreenActionsBlock = namaTypes.EditScreenActionsBlock;
import GUIActionPlaceholder = namaTypes.GUIActionPlaceholder;

let props = defineProps({
  block: {type: Object as PropType<EditScreenActionsBlock>, required: true},
  presenter: {type: Object as PropType<EditPresenter>, required: true},
  blockIndex: {type: Number, required: true},
  pageIndex: {type: Number, required: true}
});

let emit = defineEmits(['toggle'])
const metaData = props.presenter?.metadata;

function isValidToAttachActionWidget(action: GUIActionPlaceholder) {
  if (!action)
    return false;
  let actionWithId: GUIActionInfo | undefined = metaData?.entityActions?.actions![action.id!];
  if (actionWithId && (!SecurityUtils.userCanFeature(actionWithId.relatedtoFeature) || !SecurityUtils.userCanAction(
    metaData?.owner?.ownerId, action.id) && action.customization))
    return false;
  if (action.customization && action.customization.securityID && !SecurityUtils.userCanAction(metaData?.owner?.ownerId, action.customization.securityID))
    return false;
  if (action.hideInNewGUI)
    return false;
  return true;
}
</script>

<template>
  <div v-if="!(props.presenter?.isQuickCreator() && props.block && !props.block.showInQuickCreate)"
       class="tw-flex tw-items-center tw-gap-2 tw-justify-between">
    <NamaIcon default-icon="nm-actions" :block="block" :presenter="presenter" class="tw-size-4 compact:tw-size-[18px] ultra:tw-size-[15px]"/>
    <div class="tw-flex tw-gap-1.5">
      <div class="tw-flex tw-flex-wrap tw-gap-3">
        <template v-for="action in block.actions">
          <div v-if="isValidToAttachActionWidget(action)" class="tw-flex tw-items-center tw-gap-1">
            <ScreenActionWidget :presenter="presenter" :action="action"/>
          </div>
        </template>
      </div>
      <div>
        <q-btn unelevated icon="keyboard_arrow_up" class="tw-p-1 tw-rounded-md tw-text-[#757575]" @click.stop="emit('toggle')"/>
      </div>
    </div>
  </div>
</template>
